import { useToken } from '@ori/auth';
import { ApiClientProvider as GlobalApiClientProvider } from '@ori/global-api-client-react';
import { ApiClientProvider as StaticApiClientProvider } from '@ori/static-api-client-react';
import React from 'react';
import type { FC, PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';

import { swrConfig } from '../constants';
import { useConfiguration } from '../contexts';

export const ApiProvider: FC<PropsWithChildren> = ({ children }) => {
  const { currentLanguage, globalApiUrl, staticApiUrl, tenant } = useConfiguration();
  const { formattedToken } = useToken();

  // the initial token value is an empty string
  // this occasionally causes 401 response from the API GW
  if (!formattedToken) {
    return null;
  }

  return (
    <SWRConfig value={swrConfig}>
      <GlobalApiClientProvider
        baseUrl={globalApiUrl}
        tenant={tenant}
        language={currentLanguage}
        token={formattedToken}
      >
        <StaticApiClientProvider
          baseUrl={staticApiUrl}
          tenant={tenant}
          language={currentLanguage}
        >
          {children}
        </StaticApiClientProvider>
      </GlobalApiClientProvider>
    </SWRConfig>
  );
};
